export type RuleType = 'journey' | 'affinity' | 'checkout' | 'fallback';

export type TouchModel = 'firstTouch' | 'lastTouch';

export interface JourneyConfig {
  touchModel: TouchModel;
  paramName: string;
}

export interface AffinityConfig {
  metafieldNamespace: string;
  metafieldKey: string;
}

export interface CheckoutConfig {
  attributeKey: string;
}

export interface FallbackConfig {
  houseAccount: string;
}

export type RuleConfig = JourneyConfig | AffinityConfig | CheckoutConfig | FallbackConfig;

export interface Rule {
  id: string;
  shop: string;
  name: string;
  type: RuleType;
  priority: number;
  enabled: boolean;
  config: RuleConfig;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRuleInput {
  name: string;
  type: RuleType;
  enabled?: boolean;
  config: RuleConfig;
}

export interface UpdateRuleInput {
  name?: string;
  enabled?: boolean;
  config?: RuleConfig;
}

export interface PaginatedRules {
  data: Rule[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const RULE_TYPE_LABELS: Record<RuleType, string> = {
  journey: 'Journey',
  affinity: 'Affinity',
  checkout: 'Checkout',
  fallback: 'House Account',
};

export const RULE_TYPE_DESCRIPTIONS: Record<RuleType, string> = {
  journey: 'Match based on URL parameters from customer journey touchpoints',
  affinity: 'Match based on customer metafield value',
  checkout: 'Match based on cart attribute value',
  fallback: 'Default house account when no other rules match',
};
